import { View } from 'react-native'
import { styled } from '~/utils'

export const Content = styled(View, theme => {
  return {
    base: {
      paddingTop: theme.paddingInsetSixpulse,
      paddingBottom: theme.paddingInsetTwopulse,
      backgroundColor: theme.colorContainerFillDefault,
    },
    variants: {
      isCollapsed: {
        true: {
          position: 'absolute',
          opacity: 0,
        },
      },
    },
  }
})
